import script from "./inputPassworld.vue?vue&type=script&setup=true&lang=js"
export * from "./inputPassworld.vue?vue&type=script&setup=true&lang=js"

import "./inputPassworld.vue?vue&type=style&index=0&id=0efe669a&lang=scss&scoped=true"

import exportComponent from "D:\\a-mydemo\\houlang\\gs-demo\\keymemo-demo\\keymemory-pc-login\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0efe669a"]])

export default __exports__